@if (fControlName(); as fControlName) {
  <p-inputotp
    [attr.id]="fControlName"
    [formControlName]="fControlName"
    [attr.data-formControlName]="fControlName"
    [length]="6"
    [integerOnly]="true"
    variant="outlined"
    size="large"
    (keydown.enter)="onEnter($event)"
    [attr.data-testid]="testId()" />
}
